import React from "react";
import FormationItem from "./formationItem";
import "./education.css";
import { Link } from "react-router-dom";
function Formations(props) {
  return (
    <div className="formationsBlock"> 
      <div className="categoryName">{props.title}</div>
      {props.spinner ? (
        <div className="spinner-border" role="status">
        <span className="sr-only"></span>
      </div>
      ):(
        props.filter ? 
          <div className="gridFormation">
            {props.workshopsToShow.map((e, index)=>(
              <Link to={`/education/formation/${e._id}`} key={index} 
              // onClick={()=>{props.selectFormation(e)}}
              >
              <FormationItem title={e.name} />
            </Link>
            ))} 
            </div> : 
            <div className="gridFormation">
            {props.data.map((e, index)=>(
              <Link to={`/education/formation/${e._id}`} key={index} 
              // onClick={()=>{props.selectFormation(e)}}
              >
              <FormationItem title={e.name}  id = {e._id}/>
            </Link>
            ))}
             </div>    
      )}   
    </div>
  );
}

export default Formations;
